  
export function ProfileModel() {
    this.uid = "";
    this.cusRefNo = "";
    this.citizenId = "";
    this.firstName = "";
    this.lastName = "";
    this.mobileNo = "";
    this.emails = "";
    this.address = "";
    this.districtCode = "";
    this.districtName = "";
    this.provinceCode = "";
    this.provinceName = "";
    this.zipcode = "";
    this.birthDate = "";
 
    this.setValueFromCache = function (data) {
        this.uid = data.uid || "";
        this.cusRefNo = data.cus_ref_no;
        this.citizenId = data.citizen_id;
        this.firstName = data.first_name;
        this.lastName = data.last_name;
        this.mobileNo = data.mobile_no;
        this.emails = data.emails;
        this.address = data.address;
        this.districtCode = data.district_code;
        this.districtName = data.district_name;
        this.provinceCode = data.province_code;
        this.provinceName = data.province_name;
        this.zipcode = data.zipcode;
        this.birthDate = data.birth_date;
    }; 
} 